import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class LotCodeRequest{
    @ApiProperty()
    lotNumber:string;
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    presentOperation:OperationTypeEnum;
}